// This File is for rendering filters in report fFilter section
// It is used in ChartFilterGroups

import { useState, useEffect } from 'react';
import '../ChartAxes/Card.css';
import '../ChartFieldFilter/UserFilterCard.css';

import { useDrag, useDrop } from 'react-dnd';
import { useSelector } from 'react-redux';

import {
  updateChartFilterRightGroupsFilters,
  sortRightFilterGroupItems,
  revertRightFilterGroupItems,
  setLastModifiedFilter,
} from '../../redux/ChartFilterGroup/ChartFilterGroupStateActions';

import LoadingPopover from '../CommonFunctions/PopOverComponents/LoadingPopover';
import moment from 'moment';

import { ChartFilterGroupCardProps } from '../../redux/ChartFilterGroup/ChartFilterGroupInterface';
import { useDispatch } from 'react-redux';
import {
  datePatternCollections,
  datePatternSearchConditionCollections,
} from '../FilterUtils/FilterPatternCollection';
import { SelecTillDate } from '../FilterUtils/TillDate';
import { SelecRelativeFilterCard } from '../FilterUtils/RelativeFilter';
import { CustomCard } from '../FilterUtils/SearchCondition';
import { SelecPickListCard } from '../FilterUtils/PickList';
import { FilterField } from '../FilterUtils/FilterField';
import { useGetActions } from '../FilterUtils/FetchFilterData';
import { DropDownForDatePattern } from '../FilterUtils/DropDownComponent';
import { RootState } from '../../redux';
import { callQueryAPI, SetModifyOptions } from '../../redux/ChartPoperties/ChartControlsActions';
import { callQueryAPIDashboard } from '../../redux/TabTile/TabTileActionsAndMultipleDispatches';

const ChartFilterGroupCard = ({
  propKey,
  name,
  itemIndex,
  field,
  syncFilterEnabled,
  totalFiltersInGroup,
  triggerSyncFilterDataFetch,
  dsInfo,
  color,
  backgroundColor,
}: ChartFilterGroupCardProps) => {
  field.dataType = field.dataType.toLowerCase();

  const { chartGroup, token, showDash, callQueryAPIForDashboard, dashBoardGroup } = useSelector(
    (state: RootState) => ({
      chartGroup: state.chartFilterGroup,
      token: state.isLogged.accessToken,
      showDash: state.tabTileProps.showDash,
      callQueryAPIForDashboard: state.tabTileProps.callQueryAPIDashboard,
      dashBoardGroup: state.dashBoardFilterGroup,
    }),
  );

  let groupList = chartGroup.groups[name].filters || [];
  let bIndex = 0;
  const { uId, fieldname, dataType, tableId } = field;
  const originalIndex = groupList.findIndex((item: any) => item.uId === uId);
  const datasetIdOfGroup = chartGroup.groups[name].dataSetId;

  const [loading, setLoading] = useState(false);
  const [cirLoading, setCirLoading] = useState<boolean>(false);

  const dispatch = useDispatch();

  let filterFieldData = JSON.parse(JSON.stringify(field));

  const { GetPickListItems, GetRelativeFilterItems } = useGetActions({
    sortOptions: [],
    filterFieldData,
    field,
    propKey,
    token,
    itemIndex,
    name,
    triggerSyncFilterDataFetch,
    totalFiltersInGroup,
    syncFilterEnabled,
    dsInfo,
    from: 'reportFilter',
  });

  const callAPI = () => {
    if (showDash) {
      Object.keys(chartGroup.tabTile).forEach((tabTileId: string) => {
        if (dashBoardGroup.filterGroupTabTiles[name].includes(tabTileId)) {
          dispatch(callQueryAPI(tabTileId, true));
        }
      });
    }
    Object.entries(chartGroup.tabTile).forEach(([tabTileId, arr]: any) => {
      if (arr.includes(name)) {
        dispatch(callQueryAPI(tabTileId, true));
        if (!callQueryAPIForDashboard) dispatch(callQueryAPIDashboard(true));
      }
    });
    if (showDash && !callQueryAPIForDashboard) dispatch(callQueryAPIDashboard(true));
  };

  /* Initialize vaiarble to default values */

  useEffect(() => {
    async function setFieldValues() {
      let stateUpdateTrigger = true;
      if (!filterFieldData.includeexclude) filterFieldData['includeexclude'] = 'Include';

      if (filterFieldData && filterFieldData.dataType) {
        switch (filterFieldData.dataType) {
          case 'decimal':
          case 'integer':
            if (!filterFieldData.fieldtypeoption) {
              filterFieldData['fieldtypeoption'] = 'Search Condition';
            }
            break;

          case 'text':
            if (!filterFieldData.fieldtypeoption) {
              filterFieldData['fieldtypeoption'] = 'Pick List';
            }
            break;

          case 'date':
          case 'timestamp':
            if (!filterFieldData.fieldtypeoption) {
              filterFieldData['prefix'] = 'year';
              filterFieldData['fieldtypeoption'] = 'Pick List';
            }
            break;

          default:
            if (!filterFieldData.fieldtypeoption) {
              filterFieldData['fieldtypeoption'] = 'Pick List';
            }
            break;
        }
      }

      if (filterFieldData.fieldtypeoption === 'Search Condition') {
        if (dataType) {
          switch (filterFieldData.dataType) {
            case 'decimal':
            case 'integer':
              if (!filterFieldData.exprType) {
                filterFieldData['exprType'] = 'greaterThan';
              }
              break;
            case 'text':
              if (!filterFieldData.exprType) {
                filterFieldData['exprType'] = 'beginsWith';
              }
              break;
            case 'timestamp':
            case 'date':
              if (!filterFieldData.exprType) {
                filterFieldData['prefix'] = 'year';
                filterFieldData['exprType'] = 'greaterThan';
              }
              break;
            default:
              if (!filterFieldData.exprType) {
                filterFieldData['exprType'] = 'greaterThan';
              }
              break;
          }
        }
      } else if (filterFieldData.fieldtypeoption === 'Pick List') {
        filterFieldData.exprType = 'in';
        if (
          filterFieldData &&
          filterFieldData.dataType &&
          filterFieldData.dataType === 'timestamp' &&
          !filterFieldData.prefix
        ) {
          filterFieldData['prefix'] = 'year';
        }

        filterFieldData.isSingleSelection = false;

        async function _preFetchData() {
          // if (!filterFieldData.rawselectmembers || filterFieldData.rawselectmembers?.length === 0) {
          if (totalFiltersInGroup === 1 || !syncFilterEnabled) {
            await GetPickListItems();
            stateUpdateTrigger = false;
            // }
          }
        }
        filterFieldData['exprTypeTillDate'] = filterFieldData['exprTypeTillDate'] ?? false;
        filterFieldData['filterTypeTillDate'] = 'enabled';
        await _preFetchData();
      } else {
        initialRelativeFilterData();
      }

      if (stateUpdateTrigger) {
        dispatch(updateChartFilterRightGroupsFilters(name, constructChartAxesFieldObject(), false));
        dispatch(setLastModifiedFilter(name, filterFieldData.uId, false));
      }
      if (
        (!filterFieldData.rawselectmembers || filterFieldData.rawselectmembers?.length === 0) &&
        filterFieldData.fieldtypeoption === 'Pick List' &&
        totalFiltersInGroup > 1 &&
        syncFilterEnabled
      )
        triggerSyncFilterDataFetch(filterFieldData);
    }
    setFieldValues();
    // eslint-disable-next-line
  }, []);

  /// Properties and behaviour when a filter card is dragged
  const [, drag] = useDrag({
    item: {
      uId: uId,
      fieldname: fieldname,
      displayname: fieldname,
      dataType: dataType,
      tableId: tableId,
      // type: "card",
      bIndex,
      originalIndex,
      filterGroupId: name,
      datasetId: datasetIdOfGroup,
    },
    type: 'card',

    end: (dropResult, monitor) => {
      const { uId, originalIndex } = monitor.getItem();

      const didDrop = monitor.didDrop();

      if (uId && !didDrop) {
        dispatch(revertRightFilterGroupItems(name, uId, originalIndex));
      }
    },
  });

  // Properties and behaviours when another filter card is dropped over this card
  const [, drop] = useDrop({
    accept: 'card',
    canDrop: () => false,
    collect: (monitor) => ({
      backgroundColor1: monitor.isOver({ shallow: true }) ? 1 : 0,
    }),
    hover({ uId: dragUId, bIndex: fromBIndex, filterGroupId, datasetId }: any) {
      if (fromBIndex === bIndex && uId && dragUId !== uId && filterGroupId === name) {
        dispatch(sortRightFilterGroupItems(name, dragUId, uId));
      }
    },
  });

  ///Pick list CB change
  const handleCBChange = async (event: any) => {
    if (event.target.name === '(All)') {
      if (event.target.checked) {
        filterFieldData['userSelection'] = filterFieldData.rawselectmembers.map((item: any) => {
          if (item === '(Blank)') {
            return null;
          }
          if (item === '(Empty)') return '';
          return item;
        });
        filterFieldData['filterTypeTillDate'] = 'enabled';
      } else {
        filterFieldData['userSelection'] = [];
      }
    } else {
      filterFieldData['filterTypeTillDate'] = 'disabled';
      if (event.target.checked) {
        if (!isNaN(event.target.name) && isFinite(event.target.name)) {
          let _name = event.target.name;
          if (_name.includes('.')) {
            _name = parseFloat(event.target.name);
          } else {
            _name = parseInt(event.target.name);
          }
          if (_name) {
            if (_name === '(Blank)') {
              _name = null;
            } else if (_name === '(Empty)') _name = '';
            filterFieldData.userSelection.push(_name);
            if (filterFieldData.isSingleSelection) {
              filterFieldData.userSelection = [_name];
            }
          }
        } else {
          if (event.target.name === '(Blank)') {
            filterFieldData.userSelection.push(null);
            if (filterFieldData.isSingleSelection) {
              filterFieldData.userSelection = [null];
            }
          } else if (event.target.name === '(Empty)') {
            if (filterFieldData.isSingleSelection) {
              filterFieldData.userSelection = [''];
            } else filterFieldData.userSelection.push('');
          } else {
            filterFieldData.userSelection.push(event.target.name);
            if (filterFieldData.isSingleSelection) {
              filterFieldData.userSelection = [event.target.name];
            }
          }
        }
      } /*unchecked*/ else {
        let idx = filterFieldData.userSelection.findIndex((item: any) => {
          if (item === null) {
            item = '(Blank)';
          } else if (item === '') item = '(Empty)';
          return item.toString() === event.target.name.toString();
        });

        if (idx >= 0) {
          filterFieldData.userSelection.splice(idx, 1);
        }
      }

      if (!filterFieldData.userSelection.length) {
        filterFieldData['filterTypeTillDate'] = 'enabled';
      }
      let AllIdx = filterFieldData.userSelection.findIndex((item: any) => {
        if (item === null) {
          item = '(Blank)';
        } else if (item === '') item = '(Empty)';
        return item.toString() === '(All)';
      });

      if (AllIdx >= 0) {
        filterFieldData.userSelection.splice(AllIdx, 1);
      }
    }
    filterFieldData.userSelection = filterFieldData.userSelection.map((item: any) => {
      if (item === '(Blank)') {
        return null;
      }
      if (item === '(Empty') return '';
      return item;
    });

    const nullIndex = filterFieldData.userSelection.indexOf(null);
    if (nullIndex >= 0) {
      filterFieldData.userSelection = [
        ...filterFieldData.userSelection.filter((item: any) => item !== null),
        null,
      ];
    }
    if (
      filterFieldData.userSelection.length ===
      filterFieldData.rawselectmembersOriginal?.length - 1
    ) {
      filterFieldData.userSelection = ['(All)', ...filterFieldData.userSelection];
    }

    if (!syncFilterEnabled || (syncFilterEnabled && totalFiltersInGroup === 1)) {
      dispatch(updateChartFilterRightGroupsFilters(name, constructChartAxesFieldObject()));
      dispatch(setLastModifiedFilter(name, filterFieldData.uId));
      dispatch(SetModifyOptions(propKey, 'filter_group', `${name}_${filterFieldData.uId}`));
    }

    /**
     * Trigger sync filter API call if any  checkbox except all is  checked or unchecdked or if all is checked
     */
    if (filterFieldData.userSelection?.length <= 0) filterFieldData['callAPI'] = true;
    else filterFieldData['callAPI'] = false;
    if (syncFilterEnabled && totalFiltersInGroup > 1)
      await triggerSyncFilterDataFetch(filterFieldData, true);
    callAPI();
  };

  ///Initialize Relative Filter items
  const initialRelativeFilterData = () => {
    if (!filterFieldData.expTypeFromdate) {
      filterFieldData['expTypeFromdate'] = 'year';
    }
    if (!filterFieldData.expTypeTodate) {
      filterFieldData['expTypeTodate'] = 'day';
    }
    if (!filterFieldData.expTypeFromRelativeDate) {
      filterFieldData['expTypeFromRelativeDate'] = 'last';
    }
    if (!filterFieldData.expTypeToRelativeDate) {
      filterFieldData['expTypeToRelativeDate'] = 'last';
    }
    if (!filterFieldData.expTypeAnchorDate) {
      filterFieldData['expTypeAnchorDate'] = 'today';
    }
    // if (!filterFieldData.exprInputFromValueType) {
    //   filterFieldData['exprInputFromValueType'] = 2;
    // }
    // if (!filterFieldData.exprInputToValueType) {
    //   filterFieldData['exprInputToValueType'] = 2;
    // }

    if (!filterFieldData.exprInputSpecificDate) {
      filterFieldData['exprInputSpecificDate'] = moment(new Date()).format('YYYY-MM-DD');
    }
  };

  ///Till Date Switch On Click
  const handleChangeTillDate = async () => {
    if (filterFieldData.exprTypeTillDate === false) {
      filterFieldData['exprTypeTillDate'] = true;
    } else {
      filterFieldData['exprTypeTillDate'] = false;
    }
    if (!syncFilterEnabled || (syncFilterEnabled && totalFiltersInGroup === 1)) {
      dispatch(updateChartFilterRightGroupsFilters(name, constructChartAxesFieldObject()));
      dispatch(setLastModifiedFilter(name, filterFieldData.uId));
      dispatch(
        SetModifyOptions(propKey, 'filter_group', `${name}_${filterFieldData.uId}_tilldate`),
      );
    }
    if (syncFilterEnabled && totalFiltersInGroup > 1)
      await triggerSyncFilterDataFetch(filterFieldData, true);
    callAPI();
  };

  ///Custom Green/Orange Switch
  // var switchColor = '#2bb9bb';
  // if (filterFieldData.includeexclude === 'Exclude') {
  //   switchColor = '#ffb74d';
  // }

  ///set Search condition condition initiallize slider control
  const setSliderRange = () => {
    if (
      ['float', 'decimal', 'double', 'integer'].includes(dataType) &&
      filterFieldData.exprType === 'between'
    ) {
      if (
        filterFieldData.rawselectmembersOriginal &&
        !filterFieldData.greaterThanOrEqualTo &&
        !filterFieldData.lessThanOrEqualTo
      ) {
        filterFieldData.greaterThanOrEqualTo = filterFieldData.rawselectmembersOriginal[1];
        if (typeof filterFieldData.rawselectmembersOriginal[1] === 'string') {
          filterFieldData.greaterThanOrEqualTo = null;
        }
        filterFieldData.lessThanOrEqualTo =
          filterFieldData.rawselectmembersOriginal[
            filterFieldData.rawselectmembersOriginal.length - 1
          ];
        if (
          filterFieldData.rawselectmembersOriginal[
            filterFieldData.rawselectmembersOriginal.length - 1
          ] === '(Blank)'
        ) {
          filterFieldData.lessThanOrEqualTo =
            filterFieldData.rawselectmembersOriginal[
              filterFieldData.rawselectmembersOriginal.length - 2
            ];
          if (
            typeof filterFieldData.rawselectmembersOriginal[
              filterFieldData.rawselectmembersOriginal.length - 2
            ] === 'string'
          ) {
            filterFieldData.lessThanOrEqualTo = null;
          }
        }
      }
    } else if (['date', 'timestamp'].includes(dataType) && filterFieldData.prefix !== 'date') {
      if (filterFieldData.prefix === 'month') {
        filterFieldData.greaterThanOrEqualTo = 1;
        filterFieldData.lessThanOrEqualTo = 12;
      } else if (filterFieldData.prefix === 'quarter') {
        filterFieldData.greaterThanOrEqualTo = 1;
        filterFieldData.lessThanOrEqualTo = 4;
      } else if (filterFieldData.prefix === 'dayofmonth') {
        filterFieldData.greaterThanOrEqualTo = 1;
        filterFieldData.lessThanOrEqualTo = 31;
      } else if (filterFieldData.prefix === 'dayofweek') {
        filterFieldData.greaterThanOrEqualTo = 1;
        filterFieldData.lessThanOrEqualTo = 7;
      } else {
        filterFieldData.greaterThanOrEqualTo = filterFieldData.rawselectmembersOriginal[1];
        if (typeof filterFieldData.rawselectmembersOriginal[1] === 'string') {
          filterFieldData.greaterThanOrEqualTo = null;
        }
        filterFieldData.lessThanOrEqualTo =
          filterFieldData.rawselectmembersOriginal[
            filterFieldData.rawselectmembersOriginal.length - 1
          ];
        if (
          filterFieldData.rawselectmembersOriginal[
            filterFieldData.rawselectmembersOriginal.length - 1
          ] === '(Blank)'
        ) {
          filterFieldData.lessThanOrEqualTo =
            filterFieldData.rawselectmembersOriginal[
              filterFieldData.rawselectmembersOriginal.length - 2
            ];
          if (
            typeof filterFieldData.rawselectmembersOriginal[
              filterFieldData.rawselectmembersOriginal.length - 2
            ] === 'string'
          ) {
            filterFieldData.lessThanOrEqualTo = null;
          }
        }
      }
    }
  };

  const checkValidDate = (val: any) => {
    if (
      ['date', 'timestamp'].includes(dataType) &&
      filterFieldData.prefix === 'date' &&
      val.includes('-')
    ) {
      return true;
    }
    if (
      ['date', 'timestamp'].includes(dataType) &&
      filterFieldData.fieldtypeoption === 'Relative Filter' &&
      val.includes('-')
    ) {
      return true;
    }

    return false;
  };

  const setDefaultDate = (key: string, value: any) => {
    if (filterFieldData[key]) {
      filterFieldData[key] = value ? value : new Date();
    }
  };

  const setSearchConditionDate = () => {
    if (['date', 'timestamp'].includes(dataType) && filterFieldData.prefix === 'date') {
      if (filterFieldData.exprType === 'between') {
        if (checkValidDate(filterFieldData.exprInput)) {
          setDefaultDate('greaterThanOrEqualTo', filterFieldData.exprInput);
          setDefaultDate('lessThanOrEqualTo', filterFieldData.exprInput);
        }
      } else {
        if (checkValidDate(filterFieldData.lessThanOrEqualTo)) {
          setDefaultDate('exprInput', filterFieldData.lessThanOrEqualTo);
        }
      }
    }
  };

  ///Search Condition and Relative Filter Dropdown list on change handler
  const handleDropDownForPatternOnChange = async (event: any, key = 'exprType') => {
    filterFieldData[key] = event.target.value;

    if (filterFieldData.fieldtypeoption === 'Relative Filter') {
      setCirLoading(true);
      await GetRelativeFilterItems();
      setCirLoading(false);
    } else {
      if (filterFieldData.exprType === 'between') {
        //setLoading(true);
        await GetPickListItems();
        setSliderRange();
        // setLoading(false);
      }
    }
    setSearchConditionDate();

    if (filterFieldData.fieldtypeoption === 'Search Condition') {
      if (filterFieldData.exprType === 'between') {
        filterFieldData.switchEnableSearchCondition = true;
      } else {
        if (!filterFieldData.exprInput || !filterFieldData.exprInput.length) {
          filterFieldData.switchEnableSearchCondition = false;
          filterFieldData.exprTypeTillDate = false;
        } else {
          filterFieldData.switchEnableSearchCondition = true;
        }
      }
    }
    dispatch(SetModifyOptions(propKey, 'filter_group', `${name}_${filterFieldData.uId}`));

    if (!syncFilterEnabled || (syncFilterEnabled && totalFiltersInGroup === 1)) {
      if (filterFieldData.fieldtypeoption !== 'Relative Filter') {
        dispatch(updateChartFilterRightGroupsFilters(name, constructChartAxesFieldObject()));
      }
      dispatch(setLastModifiedFilter(name, filterFieldData.uId));
      dispatch(SetModifyOptions(propKey, 'filter_group', `${name}_${filterFieldData.uId}`));
      callAPI();
    }
    if (syncFilterEnabled && totalFiltersInGroup > 1)
      await triggerSyncFilterDataFetch(filterFieldData, true);
    callAPI();
  };

  ///Handle Date time grain dropdown list change
  const handleDropDownForDatePatternOnChange = async (event: any) => {
    filterFieldData['prefix'] = event.target.value;
    filterFieldData['greaterThanOrEqualTo'] = '';
    filterFieldData['lessThanOrEqualTo'] = '';
    filterFieldData.filterTypeTillDate = 'enabled';
    filterFieldData.exprTypeTillDate = false;
    if (!filterFieldData.exprInput) {
      filterFieldData['switchEnableSearchCondition'] = false;
      filterFieldData.exprTypeTillDate = false;
    }

    if (filterFieldData.fieldtypeoption === 'Search Condition' && event.target.value === 'date') {
      filterFieldData['exprInput'] = moment(new Date()).format('YYYY-MM-DD');
    }
    if (filterFieldData.fieldtypeoption === 'Search Condition' && event.target.value !== 'date') {
      if (filterFieldData['exprInput']?.includes('-')) {
        filterFieldData['exprInput'] = '';
        filterFieldData['switchEnableSearchCondition'] = false;
      }
      if (filterFieldData.exprType === 'between')
        filterFieldData['switchEnableSearchCondition'] = true;
    }
    if (filterFieldData.fieldtypeoption === 'Pick List') {
      if (filterFieldData.userSelection.length > 0) {
        filterFieldData['callAPI'] = true;
      } else {
        filterFieldData['callAPI'] = false;
      }
    }

    if (filterFieldData.fieldtypeoption === 'Pick List') {
      setLoading(true);
      dispatch(SetModifyOptions(propKey, 'filter_group', `${name}_${filterFieldData.uId}`));
      await GetPickListItems();
      setLoading(false);
      setSliderRange();
      callAPI();
      return;
    }
    setSearchConditionDate();
    if (!syncFilterEnabled || (syncFilterEnabled && totalFiltersInGroup === 1)) {
      dispatch(updateChartFilterRightGroupsFilters(name, constructChartAxesFieldObject()));

      dispatch(setLastModifiedFilter(name, filterFieldData.uId));
      dispatch(SetModifyOptions(propKey, 'filter_group', `${name}_${filterFieldData.uId}`));
    }
    if (syncFilterEnabled && totalFiltersInGroup > 1)
      await triggerSyncFilterDataFetch(filterFieldData, true);
    callAPI();
  };

  const checkForValidData = () => {
    if (
      filterFieldData.prefix === 'date' &&
      new Date(filterFieldData.greaterThanOrEqualTo) > new Date(filterFieldData.lessThanOrEqualTo)
    ) {
      filterFieldData['isInValidData'] = true;
    } else {
      if (
        parseInt(filterFieldData.greaterThanOrEqualTo) > parseInt(filterFieldData.lessThanOrEqualTo)
      ) {
        filterFieldData['isInValidData'] = true;
      }
    }
  };

  ///Search Condition and Relative Filter user input change handler

  const handleCustomRequiredValueOnBlur = async (
    val: number | string | Date,
    key = 'exprInput',
    type?: string,
  ) => {
    filterFieldData['switchEnableSearchCondition'] = true;

    if (type && type === 'date') {
      val = moment(val).format('yyyy-MM-DD');
    }

    if (!filterFieldData[key] || filterFieldData[key] !== val) {
      const oldVal = filterFieldData[key];
      filterFieldData[key] = val;
      if (![undefined, ''].includes(oldVal) && val === '') {
        filterFieldData['callAPI'] = true;
        callAPI();
      } else filterFieldData['callAPI'] = false;
      filterFieldData['isInValidData'] = false;

      if (filterFieldData.fieldtypeoption === 'Relative Filter') {
        setCirLoading(true);
        await GetRelativeFilterItems();
        setCirLoading(false);
      }

      if (key !== 'exprInput' && filterFieldData.fieldtypeoption === 'Search Condition') {
        checkForValidData();
      }

      if (key === 'exprTnput' || key === 'greaterThanOrEqualTo' || key === 'lessThanOrEqualTo') {
        if (val === null || val === '' || val === undefined) {
          filterFieldData['switchEnableSearchCondition'] = false;
          filterFieldData.exprTypeTillDate = false;
        } else {
          filterFieldData['switchEnableSearchCondition'] = true;
        }
      }

      if (filterFieldData.exprType === 'between') {
        filterFieldData['callAPI'] = true;
        callAPI();
        // sliderRange = [
        //   filterFieldData.greaterThanOrEqualTo,
        //   filterFieldData.lessThanOrEqualTo,
        // ];
      } else if (!filterFieldData.exprInput?.length) {
        filterFieldData['switchEnableSearchCondition'] = false;
        filterFieldData.exprTypeTillDate = false;
      }
      if (!syncFilterEnabled || (syncFilterEnabled && totalFiltersInGroup === 1)) {
        if (filterFieldData.fieldtypeoption !== 'Relative Filter') {
          dispatch(updateChartFilterRightGroupsFilters(name, constructChartAxesFieldObject()));
        }
        dispatch(setLastModifiedFilter(name, filterFieldData.uId));
        dispatch(SetModifyOptions(propKey, 'filter_group', `${name}_${filterFieldData.uId}`));
      }
      if (syncFilterEnabled && totalFiltersInGroup > 1)
        await triggerSyncFilterDataFetch(filterFieldData, true);
      callAPI();
    }
  };

  ///Construct Chart property object
  const constructChartAxesFieldObject = () => {
    return filterFieldData;
  };
  return (
    <div
      ref={(node: any) => drag(drop(node))}
      className="UserFilterCard"
      style={{
        marginBottom: '0.5rem',
        ...(filterFieldData.isInValidData
          ? { border: '2px red solid', backgroundColor: 'lightpink' }
          : {}),
      }}
    >
      {loading ? <LoadingPopover /> : null}

      <FilterField
        field={field}
        filterFieldData={filterFieldData}
        propKey={propKey}
        token={token}
        uID={uId}
        itemIndex={itemIndex}
        bIndex={bIndex}
        name={name}
        setCirLoading={setCirLoading}
        setLoading={setLoading}
        totalFiltersInGroup={totalFiltersInGroup}
        from="reportFilter"
        dsInfo={dsInfo}
        color={color}
        backgroundColor={backgroundColor}
      />

      {!filterFieldData.isCollapsed ? (
        <>
          <div
            className="UserSelectionDiv"
            style={
              filterFieldData.isInValidData
                ? {
                    border: '2px red solid',
                    backgroundColor: 'lightpink',
                    marginTop: 0,
                    paddingTop: '0.5rem',
                  }
                : { marginTop: 0, paddingTop: '0.5rem' }
            }
          >
            {filterFieldData.dataType === 'timestamp' || filterFieldData.dataType === 'date' ? (
              <div className="CustomRequiredField">
                {filterFieldData.fieldtypeoption === 'Pick List' ? (
                  <DropDownForDatePattern
                    items={[
                      ...datePatternCollections,
                      ...(filterFieldData.dataType === 'timestamp'
                        ? [{ key: 'hours', value: 'Hours' }]
                        : []),
                    ]}
                    handleDropDownForDatePatternOnChange={handleDropDownForDatePatternOnChange}
                    value={filterFieldData['prefix']}
                    from="reportFilter"
                    color={color}
                  ></DropDownForDatePattern>
                ) : filterFieldData.fieldtypeoption === 'Search Condition' ? (
                  <DropDownForDatePattern
                    items={[
                      ...datePatternSearchConditionCollections,
                      ...(filterFieldData.dataType === 'timestamp'
                        ? [{ key: 'hours', value: 'Hours' }]
                        : []),
                    ]}
                    handleDropDownForDatePatternOnChange={handleDropDownForDatePatternOnChange}
                    value={filterFieldData['prefix']}
                    from="reportFilter"
                    color={color}
                  ></DropDownForDatePattern>
                ) : null}
              </div>
            ) : null}
            {filterFieldData.fieldtypeoption === 'Pick List' ? (
              <>
                <SelecPickListCard
                  handleCBChange={handleCBChange}
                  allOptions={filterFieldData?.rawselectmembers}
                  userSelection={filterFieldData?.userSelection}
                  shouldExclude={filterFieldData?.includeexclude === 'Exclude'}
                  loading={loading}
                  isSingleSelection={filterFieldData.isSingleSelection}
                  color={color}
                  from="reportFilter"
                ></SelecPickListCard>
                {filterFieldData.dataType === 'timestamp' || filterFieldData.dataType === 'date' ? (
                  <SelecTillDate
                    isDisabled={false}
                    shouldExclude={filterFieldData?.includeexclude === 'Exclude'}
                    timeGrain={filterFieldData.prefix}
                    isChecked={filterFieldData.exprTypeTillDate}
                    handleChangeTillDate={handleChangeTillDate}
                    color={color}
                  ></SelecTillDate>
                ) : null}
              </>
            ) : filterFieldData.fieldtypeoption === 'Relative Filter' ? (
              <SelecRelativeFilterCard
                filterFieldData={filterFieldData}
                handleCustomRequiredValueOnBlur={handleCustomRequiredValueOnBlur}
                handleDropDownForPatternOnChange={handleDropDownForPatternOnChange}
                cirLoading={cirLoading}
                fromDate={filterFieldData.fromDate}
                toDate={filterFieldData.toDate}
                anchorDate={filterFieldData.expTypeAnchorDate}
                specificDate={filterFieldData.exprInputSpecificDate}
                relativeConditionFromType={filterFieldData.expTypeFromRelativeDate}
                relativeConditionToType={filterFieldData.expTypeToRelativeDate}
                from="reportFilter"
              ></SelecRelativeFilterCard>
            ) : (
              <>
                <CustomCard
                  filterFieldData={filterFieldData}
                  handleCustomRequiredValueOnBlur={handleCustomRequiredValueOnBlur}
                  handleDropDownForPatternOnChange={handleDropDownForPatternOnChange}
                  dataType={filterFieldData.dataType}
                  operator={filterFieldData.exprType}
                  shouldExclude={filterFieldData?.includeexclude === 'Exclude'}
                  timeGrain={filterFieldData.prefix}
                  value={filterFieldData.exprType}
                  inputValue={filterFieldData.exprInput}
                  inputValueGreaterThanOrEqualTo={filterFieldData.greaterThanOrEqualTo}
                  inputValueLessThanOrEqualTo={filterFieldData.lessThanOrEqualTo}
                  from="reportFilter"
                  color={color}
                  backgroundColor={backgroundColor}
                ></CustomCard>
              </>
            )}
          </div>
        </>
      ) : null}
    </div>
  );
};

export default ChartFilterGroupCard;
